const sectionCode = "SPRO2";
const chartCode = "C006x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T06Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T06Procedures };
